import { defineStore } from 'pinia';
import { ref } from 'vue';

const DEFAULT_TRAVELERS = Object.freeze({ adults: 1, children: 0, pets: 0 });
const DEFAULT_REFINE_VALIDATION = Object.freeze({
  needsTravellerValidation: false,
  isValidForSearch: true,
});

export const useRefineStore = defineStore('refine', () => {
  const budgetAmount = ref('');
  const travelersData = ref({ ...DEFAULT_TRAVELERS });

  const selectedThemes = ref([]);
  const selectedActivities = ref([]);
  const selectedTravelMethods = ref([]);
  const selectedAccommodations = ref([]);
  const selectedTripTypes = ref([]);
  const selectedSpecialRequirements = ref([]);

  const selectedRegions = ref([]);
  const selectedTripTypesDiscover = ref([]);
  const selectedWhoIsGoing = ref(null);
  const selectedDistanceType = ref(null);
  const travelDistanceValue = ref(3);
  const tripDirection = ref('return');

  // Quick date isn't just refine, arguably part of main search form but it was mixed in.
  // We'll keep it here since it was passed down, actually wait, whereWhen / quickDate might be main query.
  // Let's put it here per the plan.
  const selectedQuickDate = ref('');
  
  const refineValidation = ref({ ...DEFAULT_REFINE_VALIDATION });

  const clearAll = () => {
    budgetAmount.value = '';
    travelersData.value = { ...DEFAULT_TRAVELERS };
    
    selectedThemes.value = [];
    selectedActivities.value = [];
    selectedTravelMethods.value = [];
    selectedAccommodations.value = [];
    selectedTripTypes.value = [];
    selectedSpecialRequirements.value = [];
    
    selectedRegions.value = [];
    selectedTripTypesDiscover.value = [];
    selectedWhoIsGoing.value = null;
    selectedDistanceType.value = null;
    travelDistanceValue.value = 3;
    tripDirection.value = 'return';
    selectedQuickDate.value = '';

    refineValidation.value = { ...DEFAULT_REFINE_VALIDATION };
  };

  const setValidation = (validation) => {
    refineValidation.value = { ...refineValidation.value, ...validation };
  };

  return {
    budgetAmount,
    travelersData,
    selectedThemes,
    selectedActivities,
    selectedTravelMethods,
    selectedAccommodations,
    selectedTripTypes,
    selectedSpecialRequirements,
    selectedRegions,
    selectedTripTypesDiscover,
    selectedWhoIsGoing,
    selectedDistanceType,
    travelDistanceValue,
    tripDirection,
    selectedQuickDate,
    refineValidation,
    clearAll,
    setValidation,
  };
});
